import { Outlet } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";

import {
  Bookmarks,
  BubbleChart,
  CompareArrows,
  Domain,
  Person,
  QueryStats,
  RocketLaunch,
  UploadFile,
} from "@mui/icons-material";

import { createQueryClient } from "@/api";
import { AppContainer, AuthContainer } from "@/components/containers";
import { DialogRoot } from "@/components/molecules";
import {
  ActivationProvider,
  AudienceProvider,
  CompareProvider,
  SnackbarProvider,
  DialogProvider,
  ViewModeProvider,
} from "@/context";
import { Navigation } from "@/types";

const NAVIGATION: Navigation = [
  {
    segment: "audience",
    title: "Audiences",
    icon: <Person />,
    pattern: "audience/:id?/:segment?",
  },
  {
    segment: "upload",
    title: "Upload",
    icon: <UploadFile />,
    pattern: "upload/:id?/:segment?",
    hidden: true,
  },
  {
    segment: "mindset",
    title: "Mindsets",
    icon: <BubbleChart />,
    pattern: "mindset/:id?/:segment?",
    hidden: true,
  },
  {
    segment: "library",
    title: "Audience Library",
    icon: <Bookmarks />,
    pattern: "library/:id?/:segment?",
    hidden: true,
    client: "imedia"
  },
  {
    segment: "activation",
    title: "Activation",
    icon: <RocketLaunch />,
    pattern: "activation/:id?/:segment?",
    hidden: true,
  },
  {
    segment: "compare",
    title: "Compare",
    icon: <CompareArrows />,
    pattern: "compare/:audienceIds?",
    hidden: true,
  },
  {
    segment: "site",
    title: "Sites",
    icon: <Domain />,
    pattern: "site/:id?/:segment?",
    hidden: true,
    client: "imedia"
  },
  {
    segment: "measurement",
    title: "Measurement",
    icon: <QueryStats />,
    hidden: true,
  },
  // {
  //   segment: 'explore',
  //   title: 'Explore',
  //   icon: <Explore />,
  // },
];

// One cache for the whole app, so fetched data survives moving between pages
const queryClient = createQueryClient();

function App() {
  return (
    <AuthContainer>
      <QueryClientProvider client={queryClient}>
        <SnackbarProvider>
          <DialogProvider>
            <ViewModeProvider>
              <AudienceProvider>
                <ActivationProvider>
                  <CompareProvider>
                    <AppContainer navigation={NAVIGATION}>
                      <Outlet />
                      <DialogRoot />
                    </AppContainer>
                  </CompareProvider>
                </ActivationProvider>
              </AudienceProvider>
            </ViewModeProvider>
          </DialogProvider>
        </SnackbarProvider>
      </QueryClientProvider>
    </AuthContainer>
  );
}

export default App;
